import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, HandCoins, Send } from "lucide-react";
import { useAuthedApi, formatINR } from "../../lib/api";

export default function Leads({ kind }) {
  const api = useAuthedApi();
  const [items, setItems] = useState(null);
  useEffect(() => { api("get", `/leads/${kind}`).then(setItems); }, [api, kind]);

  if (!items) return <p className="text-gray-500">Loading...</p>;
  if (!items.length) return <div className="lux-card p-16 text-center text-gray-400" data-testid={`no-leads-${kind}`}>{kind === "received" ? "No offers or enquiries yet." : "You haven't sent any offers or enquiries yet."}</div>;
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid={`leads-${kind}`}>
      {items.map((l) => (
        <div key={l.id} className="lux-card p-6 space-y-3" data-testid={`lead-${l.id}`}>
          <div className="flex items-center justify-between">
            <span className={`text-[10px] uppercase tracking-widest font-bold px-2.5 py-1 rounded-full flex items-center gap-1 ${l.type === "offer" ? "text-black" : "text-[#E5C158] border border-[#D4AF37]/40"}`} style={l.type === "offer" ? { background: "var(--gold-grad)" } : {}}>
              {l.type === "offer" ? <HandCoins className="w-3 h-3" /> : <Send className="w-3 h-3" />}{l.type}
            </span>
            <span className="text-xs text-gray-500">{new Date(l.created_at).toLocaleString("en-IN")}</span>
          </div>
          <Link to={`/cars/${l.listing_id}`} className="font-semibold hover:text-[#E5C158] block">{l.listing_title}</Link>
          {l.type === "offer" && <p className="text-sm">Offer <span className="font-display text-2xl gold-text">{formatINR(l.offer_amount)}</span> <span className="text-gray-500 text-xs">vs asking {formatINR(l.listing_price)}</span></p>}
          {l.message && <p className="text-sm text-gray-300 italic">"{l.message}"</p>}
          {kind === "received" && (
            <div className="flex items-center justify-between pt-3 border-t border-white/5">
              <p className="text-sm">{l.name}</p>
              <div className="flex gap-2">
                <a href={`tel:${l.phone}`} className="btn-outline !px-3 !py-1.5 text-xs" data-testid={`lead-call-${l.id}`}><Phone className="w-3 h-3" />{l.phone}</a>
                <a href={`https://wa.me/91${l.phone.replace(/\D/g, "").slice(-10)}`} target="_blank" rel="noreferrer" className="px-3 py-1.5 rounded-full bg-[#25D366] text-black text-xs font-semibold flex items-center gap-1" data-testid={`lead-wa-${l.id}`}><MessageCircle className="w-3 h-3" />WhatsApp</a>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
